export default function initTabs() {
    let tabContainers = document.querySelectorAll('.tabs');

    tabContainers.forEach((tabContainer) => {

        let tabPanels = tabContainer.querySelectorAll('.tab-panel');

        if (tabPanels.length == 0) {
            console.error('No tab panels found in tab component:', tabContainer);
            return;
        }

        let tabHeader = tabContainer.querySelector('.tab-header');
        let tabLabels = tabContainer.querySelectorAll('.tab-label');
        let activeIndex = parseInt(tabContainer.dataset.activeTabIndex) || 0;

        // Ensure activeIndex is within valid range
        if (activeIndex < 0 || activeIndex >= tabLabels.length) {
            activeIndex = 0;
        }

        const setActiveTabPanel = (index) => {
            tabPanels.forEach((panel) => {
                panel.classList.remove('active');
            });

            tabPanels[index].classList.add('active');
        }

        const setActiveTabLabel = (index) => {
            tabLabels.forEach((label) => {
                label.classList.remove('active');
            });

            tabLabels[index].classList.add('active');
        }

        tabLabels.forEach((label, index) => {
            label.addEventListener('click', () => {
                setActiveTabLabel(index);
                setActiveTabPanel(index);
                activeIndex = index;
            });
        });

        setActiveTabLabel(activeIndex);
        setActiveTabPanel(activeIndex);
    });

}